var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Combos","hide-footer":"","size":"lg","id":"combos"}},[_c('div',[_c('view-component',{attrs:{"model_name":"combo"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }